// const env = 'dev'
const env = 'prod'
export const baseUrl = env === 'dev' ? 'https://cim-back.pm.sirun.net/' : 'https://cim-back.pm.sirun.net/'
// export const baseUrl = env === 'dev' ? 'https://cim-back.pm.sirun.net/' : 'http://127.0.0.1:5555/'

export const mockEnabled = process.env.VUE_APP_ENABLE_MOCK === 'true'
export const mockUser = {
  userid: process.env.VUE_APP_MOCK_USERID || '',
  name: process.env.VUE_APP_MOCK_USER_NAME || '',
}

if (mockEnabled && (!mockUser.userid || !mockUser.name)) {
  throw new Error('开启 mock 时必须配置 VUE_APP_MOCK_USERID 和 VUE_APP_MOCK_USER_NAME')
}
